// Function is used to format an address string for the URL.
export function formatAddressForUrl(address) {
    // Replace hyphens with a *, so we know how to unformat them later
    const formattedAddress = address.replace(/-/g, "*");
    
    // Replace consecutive spaces, commas, or a combination of both with a single hyphen
    const cleanedAddress = formattedAddress.replace(/[\s,]+/g, "-");
    return cleanedAddress;
}